import { ICommonSettings } from "@kuika/kuika-cl-model";
import { PureComponent, ReactNode } from "react";
import { ICommonConfigDeleteFunctionParams, ICommonConfigSaveFunctionParams } from "../app-settings-config-container";
import { ConfigSettingSelect } from "../config-setting-select";
import { ConfigSearchEngineSettings } from "./app-settings-config-search-engine";

export interface IConfigSearchEngineInputState {
  showModal: boolean;
  editingId: string;
}

export interface IConfigSearchEngineInputProps {
  parentConfigValue?: string | null;
  commonSettings: ICommonSettings;
  getSectionDescription: (contentKey: string) => ReactNode;
  handleUpdateCustomFormInput: (formItemName: string[], value: string | null) => void;
  handleCreateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleUpdateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleDeleteCommonConfig: (params: ICommonConfigDeleteFunctionParams) => void;
}

export class ConfigSearchEngineInput extends PureComponent<
  IConfigSearchEngineInputProps,
  IConfigSearchEngineInputState
> {
  formInputName = ["apiConfig", "searchEngineSettingsId"];

  constructor(props: IConfigSearchEngineInputProps) {
    super(props);
    this.state = { showModal: false, editingId: "" };
  }

  openModal = () => this.setState({ showModal: true, editingId: "" });

  closeModal = () => this.setState({ showModal: false });

  setEditing = (id: string) => {
    if (!id) return;
    this.setState({ editingId: id, showModal: true });
  };

  handleRestore = (): void => {
    this.props.handleUpdateCustomFormInput?.(this.formInputName, this.props.parentConfigValue ?? null);
  };

  render() {
    const {
      parentConfigValue,
      commonSettings,
      getSectionDescription,
      handleUpdateCustomFormInput,
      handleCreateCommonConfig,
      handleUpdateCommonConfig,
      handleDeleteCommonConfig
    } = this.props;

    const options = (commonSettings.searchEngineSettings || []).map((x) => ({ id: x.id, name: x.name }));

    return (
      <>
        <ConfigSearchEngineSettings
          formInputName={this.formInputName}
          showModal={this.state.showModal}
          closeModal={this.closeModal}
          editingSearchEngineId={this.state.editingId}
          commonSettings={commonSettings}
          getSectionDescription={getSectionDescription}
          handleCreateCommonConfig={handleCreateCommonConfig}
          handleUpdateCommonConfig={handleUpdateCommonConfig}
          handleDeleteCommonConfig={handleDeleteCommonConfig}
        />
        <ConfigSettingSelect
          label="Full-Text Search Engine"
          formInputName={this.formInputName}
          options={options}
          normalize={(val: string | null) => (val === "null" || val === "" ? null : val)}
          tooltipContentKey="appsettings_searchengine"
          onAddNew={this.openModal}
          onEdit={this.setEditing}
          parentConfigValue={this.props.parentConfigValue}
          onRestore={this.handleRestore}
          dropdownTestId="appSettingsSearchEngineDropdown"
          addNewTestId="appSettingsSearchEngineDropdownAddNew"
        />
      </>
    );
  }
}
